<template>
  <div class="quantity-form">
    <div class="quantity-form__text">
      <div>
        Estás seleccionando <br>
        <b>{{ value }} {{ value === 1 ? 'Entrada' : 'Entradas'}}</b>
      </div>
      <small>{{ versus.name }}</small>
    </div>
    <div class="quantity-form__display">
      <span>{{ value }}</span>
    </div>
    <div>
      <div class="quantity-control">
        <a href="#" @click.prevent="increment()" class="increment">
          +
        </a>
        <a v-if="value > 1" href="#" @click.prevent="decrement()" class="decrement">
          -
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['value', 'stock', 'code'],
  methods: {
    increment() {
      if (this.value >= this.stock) return;
      const vl = (this.code === 'SUR' || this.code === 'NORTE') ? 3 : 4;
      if (this.value > vl) return;
      const val = this.value + 1;
      this.$emit('input', val);
    },
    decrement() {
      if (this.quantity === 1) return;
      const val = this.value - 1;
      this.$emit('input', val);
    },
  },
};
</script>
